export default __webpack_public_path__ + "static/getArtime-0f1382eda8d06b190e09975f319badac.png";